// src/pages/Contact.js
import ContactSection from "../components/ContactSection";

export default function Contact() {
  return <ContactSection />;
}
